import {Component, Input} from '@angular/core'
import {StaticComponentInstance, StaticFormLayoutConfig} from '../../static-form/static-form.types'
import {Observable} from 'rxjs'
import {FormArray, FormControl, Validators} from '@angular/forms'
import {TypedFormGroup} from '../../../../../../core/forms/form-controls.model'
import {
  SolarInstallation_Addons,
  SolarInstallation_BuildingType,
  SolarInstallation_DesiredSystem,
  SolarInstallation_MostImportantFactor,
  SolarInstallationStaticJobQuestionsInput,
  StaticJobQuestionsInput,
} from '../../../../../../../__generated__/types'
import {map} from 'rxjs/operators'
import {SelectItem} from '../../../../../../craft/forms/select/select.component'
import {TranslocoService} from '@ngneat/transloco'

@Component({
  templateUrl: './solar-installation-static-form.component.html',
  styleUrls: ['../.././gradual-reveal.css'],
})
export class SolarInstallationStaticFormComponent implements StaticComponentInstance {
  @Input({required: true}) form!: TypedFormGroup<SolarInstallationStaticJobQuestionsInput>

  readonly DesiredSystem = SolarInstallation_DesiredSystem
  readonly AddonValues = Object.values(SolarInstallation_Addons)
  readonly BuildingType = SolarInstallation_BuildingType
  readonly BuildingTypeOptions: SelectItem[]
  readonly ImportanceFactorValues: SolarInstallation_MostImportantFactor[]

  constructor(private readonly translationService: TranslocoService) {
    this.BuildingTypeOptions = Object.values(SolarInstallation_BuildingType)
      .map(value => ({
        key: value,
        valueTranslationKey: 'createJobRequest.solarInstallation.buildingType.' + value,
      }))
      .sort((a, b) => {
        // Other option goes last
        if (a.key === SolarInstallation_BuildingType.Other) return 1
        else return -1
      })
    this.ImportanceFactorValues = Object.values(SolarInstallation_MostImportantFactor).sort((a, b) => {
      // No preferences goes last
      if (a === SolarInstallation_MostImportantFactor.NoPreference) return 1
      else return -1
    })
  }

  public static createForm(): TypedFormGroup<SolarInstallationStaticJobQuestionsInput> {
    const addons = new FormArray<FormControl>([])
    Object.values(SolarInstallation_Addons).forEach(addon => {
      addons.push(new FormControl(false))
    })

    return new TypedFormGroup<SolarInstallationStaticJobQuestionsInput>({
      desiredSystem: new FormControl<SolarInstallation_DesiredSystem | undefined>(undefined, [Validators.required]),
      otherDesiredSystem: new FormControl<string | undefined>(undefined),
      roofSquareMeters: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(0)]),
      buildingType: new FormControl<SolarInstallation_BuildingType | undefined>(undefined, [Validators.required]),
      otherBuildingType: new FormControl<string | undefined>(undefined),
      mostImportantFactor: new FormControl<SolarInstallation_MostImportantFactor | undefined>(undefined, [
        Validators.required,
      ]),
      addons,
    })
  }

  layout$(): Observable<StaticFormLayoutConfig> {
    return this.translationService
      .selectTranslate('createJobRequest.solarInstallation.priceInfoText')
      .pipe(map(infoText => ({infoText})))
  }

  questionsInput(): StaticJobQuestionsInput {
    const addons = this.form?.value.addons
      .map((checked, i) => (checked ? this.AddonValues[i] : null))
      .filter((v): v is SolarInstallation_Addons => !!v)

    return {
      solarInstallation: {
        desiredSystem: this.form?.value.desiredSystem || SolarInstallation_DesiredSystem.RoofPhotovoltaic,
        otherDesiredSystem: this.form?.value.otherDesiredSystem || undefined,
        roofSquareMeters: this.form?.value.roofSquareMeters || 0,
        buildingType: this.form?.value.buildingType || SolarInstallation_BuildingType.SingleFamilyHouse,
        otherBuildingType: this.form?.value.otherBuildingType || undefined,
        mostImportantFactor: this.form?.value.mostImportantFactor || SolarInstallation_MostImportantFactor.NoPreference,
        addons: addons || [],
      },
    }
  }
}
